import { observable, action, computed } from "mobx"
import { MembersMapI, BookingFlow } from "../../BookingFlow"
import { BookingDB } from "../../db/BookingLightDB"
import { SessionGroup } from "BookingSystem/db/SessionGroup"
import { Member } from "BookingSystem/db/Member"
import { SessionType } from "BookingSystem/db/SessionType"

export class SessionEditor implements MembersMapI {
  constructor(db: BookingDB, flow: BookingFlow, session: SessionGroup) {
    this.flow = flow
    this.db = db
    this.sessionGroup = session
  }

  @observable
  flow: BookingFlow

  @observable
  db: BookingDB

  @observable
  adult: Member

  @observable
  sessionGroup: SessionGroup

  @observable
  isSelectable = true

  @observable
  isEditable = false

  @computed
  get memberList() {
    return this.flow.currentBooking.availableMembersForSession(
      this.sessionGroup.session
    )
  }

  @observable
  selectedSessionType: SessionType

  @computed
  get name() {
    return `${this.selectedSessionType.object.name} ${
      this.sessionGroup.session.timeSlot
    }`
  }

  has(member: Member) {
    return this.sessionGroup.object.$members[member.id] != undefined
  }

  onEdit(member: Member) {}

  onDelete(member: Member) {}

  @action.bound
  toggleMembership(member: Member) {
    if (this.has(member)) {
      this.sessionGroup.removeMember(member)
    } else {
      this.sessionGroup.addMember(member)
    }
  }

  @action.bound
  toggleAllMembers() {
    this.sessionGroup.members.forEach(this.toggleMembership)
  }
}
